export function messageActions() {
    $(document)
        .off('click.growtypeChatMessageActions', '.g-chatform-message-actions-selector')
        .on('click.growtypeChatMessageActions', '.g-chatform-message-actions-selector', function (event) {
            event.stopPropagation();

            const $actions = $(this).closest('.g-chatform-message-actions');
            const $options = $actions.find('.g-chatform-message-actions-options');

            // Hide all other visible options
            $('.g-chatform-message-actions-options').not($options).each(function () {
                if ($(this).is(':visible')) {
                    $(this).fadeOut(200, function () {
                        $(this).css('margin-left', ''); // reset after fully hidden
                    });
                }
            });

            // Toggle current
            if (!$options.is(':visible')) {
                // Temporarily show offscreen to calculate position
                $options.css({ visibility: 'hidden', display: 'block' });
                adjustOptionsPosition($options);
                $options.css({ visibility: '', display: 'none' });

                // Now fade in at correct position
                $options.fadeIn(200);
            } else {
                // Hide current
                $options.fadeOut(200, function () {
                    $(this).css('margin-left', '');
                });
            }
        });

    /**
     * Keep options inside the message horizontally and the visible chat vertically.
     */
    function adjustOptionsPosition($options) {
        // A previous opening may have shifted or constrained this menu.
        $options.css({ 'margin-left': '', top: '', 'max-height': '', 'overflow-y': '' });

        const $parent = $options.closest('.g-chatform-message');
        const parentOffset = $parent.offset();
        const parentWidth = $parent.outerWidth();
        const optionsOffset = $options.offset();
        const optionsWidth = $options.outerWidth();

        // If overflowing right, shift left
        if (optionsOffset.left + optionsWidth > parentOffset.left + parentWidth) {
            const shift = (optionsOffset.left + optionsWidth) - (parentOffset.left + parentWidth);
            $options.css('margin-left', `-${shift + 0}px`); // add some padding
        } else {
            $options.css('margin-left', ''); // reset if no overflow
        }

        const content = $options.closest('.g-chatform-content')[0];
        if (!content) {
            return;
        }

        const contentRect = content.getBoundingClientRect();
        const visibleTop = Math.max(0, contentRect.top + content.clientTop) + 4;
        const visibleBottom = Math.min(window.innerHeight,
            contentRect.top + content.clientTop + content.clientHeight) - 4;

        // Very short chat containers still need to expose every action.
        $options.css({
            'max-height': `${Math.max(0, visibleBottom - visibleTop)}px`,
            'overflow-y': 'auto',
        });

        const menu = $options[0].getBoundingClientRect();
        const trigger = $options.closest('.g-chatform-message-actions')
            .find('.g-chatform-message-actions-selector')[0].getBoundingClientRect();
        let top = menu.top;

        if (menu.bottom > visibleBottom) {
            top = trigger.top - menu.height - 4;
        }

        top = Math.max(visibleTop, Math.min(top, visibleBottom - menu.height));
        $options.css('top', `${parseFloat($options.css('top')) + top - menu.top}px`);
    }
}

// Initialize global handlers only once
if (!window.chatMessageActionsGlobalInitialized) {
    window.chatMessageActionsGlobalInitialized = true;

    // Prevent closing when clicking inside actions
    $(document).on('click', '.g-chatform-message-actions', function (event) {
        event.stopPropagation();
    });

    // Click outside = close
    $('body').on('click', function () {
        $('.g-chatform-message-actions-options').fadeOut(200, function () {
            $(this).css('margin-left', ''); // reset after fully hidden
        });
    });
}
